import { Helmet } from "react-helmet-async";
import services from "../data/services.json";
import details from "../data/details.json";

export default function HomeHelmet() {
  const serviceTitles = services.services
    .map((service) => service.title)
    .join(", ");

  return (
    <Helmet>
      <title>{details.sitetitle}</title>
      <meta
        name="description"
        content="Η Θεραπευτική γωνιά παιδιού & ενήλικα αποτελείται από εξειδικευμένους και ειδικά καταρτισμένους θεραπευτές που αναλαμβάνουν την πλήρη αξιολόγηση και θεραπευτική παρέμβαση παρέχοντας τις υπηρεσίες τους με αγάπη, σεβασμό και ενσυναίσθηση σε κάθε άτομο/οικογένεια."
      />
      <meta
        name="keywords"
        content={
          "Θεραπευτική γωνιά, παιδιού, ενήλικα, θεραπευτές, αξιολόγηση, παρέμβαση, αγάπη, σεβασμό, ενσυναίσθηση, οικογένεια, " +
          serviceTitles
        }
      />
      <meta
        property="og:title"
        content={details.title + " " + details.subtitle}
      />
      <meta
        property="og:description"
        content="Η Θεραπευτική γωνιά παιδιού & ενήλικα αποτελείται από εξειδικευμένους και ειδικά καταρτισμένους θεραπευτές που αναλαμβάνουν την πλήρη αξιολόγηση και θεραπευτική παρέμβαση παρέχοντας τις υπηρεσίες τους με αγάπη, σεβασμό και ενσυναίσθηση σε κάθε άτομο/οικογένεια."
      />
      <link rel="canonical" href="https://therapycorner.gr/" />
    </Helmet>
  );
}
